import React, { useRef, useEffect, useState } from 'react';
import { Button } from './button';
import { Download, ChevronDown } from 'lucide-react';

interface TableExportMenuProps {
  onExcel: () => void;
  onCSV: () => void;
  onPDF: () => void;
}

export const TableExportMenu: React.FC<TableExportMenuProps> = ({ onExcel, onCSV, onPDF }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Cerrar el menú al hacer clic fuera
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <div ref={ref} className="relative">
      <Button
        onClick={() => setOpen(v => !v)}
        className="bg-transparent hover:bg-white/5 text-foreground border border-white/10 px-3 rounded-[6px] font-medium shadow-none transition-colors flex items-center gap-2 h-8 text-[13px]"
      >
        <Download className="h-3.5 w-3.5 text-muted-foreground" />
        Exportar
        <ChevronDown className={`h-3 w-3 text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} />
      </Button>
      {open && (
        <div className="absolute right-0 mt-2 z-10 bg-[#1C1E23] border border-white/10 rounded-lg shadow-xl min-w-[200px] overflow-hidden animate-in fade-in zoom-in-95 duration-200 p-1">
          <div className="px-2 py-1.5 text-xs font-medium text-muted-foreground">Formatos</div>
          <button className="w-full text-left px-2 py-1.5 hover:bg-white/5 text-sm text-foreground rounded-[4px] transition-colors flex items-center gap-2" onClick={() => { onExcel(); setOpen(false); }}>
            <span className="w-4 h-4 flex items-center justify-center text-emerald-500">x</span>
            Exportar a Excel
          </button>
          <button className="w-full text-left px-2 py-1.5 hover:bg-white/5 text-sm text-foreground rounded-[4px] transition-colors flex items-center gap-2" onClick={() => { onCSV(); setOpen(false); }}>
            <span className="w-4 h-4 flex items-center justify-center text-blue-500">,</span>
            Exportar a CSV
          </button>
          <button className="w-full text-left px-2 py-1.5 hover:bg-white/5 text-sm text-foreground rounded-[4px] transition-colors flex items-center gap-2" onClick={() => { onPDF(); setOpen(false); }}>
            <span className="w-4 h-4 flex items-center justify-center text-rose-500">p</span>
            Exportar a PDF
          </button>
        </div>
      )}
    </div>
  );
}; 